import { createContext, useContext, useEffect, useState } from "react";
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  getAuth,
} from "firebase/auth";
import { auth, db } from "../firebase-config";
import { doc, setDoc } from "firebase/firestore";
import { updateProfile } from "firebase/auth";
import { Toast } from "@chakra-ui/react";

const UserContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [userRef, setUserRef] = useState({});

  const createUserHook = (name, usuario, filial, cargo, email, password) => {
    return createUserWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        // Signed in
        const user = userCredential.user;
        // console.log("USUÁRIO CRIADO!");
        // ...
        await setDoc(
          doc(db, "users", user.uid),
          {
            name: name,
            usuario: usuario,
            filial: filial,
            cargo: cargo,
            email: email,
          }
          // console.log("DOC DO USUÁRIO CRIADO!")
        );
        updateProfile(auth.currentUser, {
          displayName: usuario,
        })
          .then(() => {
            // Profile updated!
            // ...
            // console.log("Display Definido");
          })
          .catch((error) => {
            // An error occurred
            // ...
            console.log(error);
          });
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // ..
      });
  };

  const loginHook = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const logoutHook = () => {
    return signOut(auth);
  };

  const PasswordReset = (email) => {
    return sendPasswordResetEmail(auth, email);
  };

  useEffect(() => {
    const unsubscribre = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => {
      unsubscribre();
    };
  });

  return (
    <UserContext.Provider
      value={{
        loginHook,
        user,
        logoutHook,
        createUserHook,
        userRef,
        setUserRef,
        setUser,
        PasswordReset,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(UserContext);
};
